import { createI18n } from "vue-i18n";
import languages, { Language } from "@/utils/languages";

import es from "@/assets/lang/app/es.json";
import en from "@/assets/lang/app/en.json";
import pt from "@/assets/lang/app/pt.json";
import tr from "@/assets/lang/app/tr.json";

const getLanguage = (code: string): Language => {
  const lang = languages.find((val) => val.code === code) as Language;
  return lang;
};

const ES = getLanguage("es");
const EN = getLanguage("en");
const PT = getLanguage("pt");
const TR = getLanguage("tr");

const messages = { es, en, pt, tr };

const dateTimeFormats = {
  es: ES.dateTimeFormat,
  en: EN.dateTimeFormat,
  pt: PT.dateTimeFormat,
  tr: TR.dateTimeFormat,
  //de: languages.find(val => val.code === 'de').dateTimeFormat
};

const numberFormats = {
  es: ES.numberFormat,
  en: EN.numberFormat,
  pt: PT.numberFormat,
  tr: TR.numberFormat,
  //de: languages.find(val => val.code === 'de').numberFormat
};

export default defineNuxtPlugin(({ vueApp }) => {
  const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: languages[0].code,
    allowComposition: true,
    messages,
    dateTimeFormats,
    numberFormats,
  });

  vueApp.use(i18n);
  return {
    provide: {
      i18n: i18n.global,
    },
  };
});
